import styled from '@emotion/styled';

const ScrollCol = ({ maxWidth, maxHeight, children, ...rest }) => {
  return (
    <Scroll style={{ maxHeight, maxWidth }} {...rest}>
      {children}
    </Scroll>
  );
};

const Scroll = styled.div`
  max-height: ${(props) => props.maxheight};
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #3f3f3f;
    height: 50px;
  }

  &::-webkit-scrollbar {
    width: 3px;
    background-color: #6f1d1b;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fcfbb7;
    border-radius: 10px;
    height: 50px;
  }
`;

export default ScrollCol;
